function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { padding } from '@bydesign-ui/utils';
export var ScheduleSelectType;

(function (ScheduleSelectType) {
  ScheduleSelectType["NONE"] = "none";
  ScheduleSelectType["SELECTED"] = "selected";
})(ScheduleSelectType || (ScheduleSelectType = {}));

export var SchedulePanel = function () {
  function SchedulePanel(root) {
    _classCallCheck(this, SchedulePanel);

    this.root = root;
  }

  _createClass(SchedulePanel, [{
    key: "getScheduleList",
    value: function getScheduleList() {
      var _this = this;

      var scheduleList = [];
      var datasource = this.root.getDatasource();
      var divider = this.root.getDivider();
      datasource.forEach(function (label) {
        var item = {
          label: label,
          items: []
        };
        var len = divider * 24;

        for (var i = 0; i < len; i++) {
          var col = {
            label: label,
            value: i,
            selectType: _this.root.getItemSelectType(label, i),
            formatValue: _this.getFormatValue(i),
            disabled: _this.root.isTimeDisabled(label, i)
          };
          item.items.push(col);
        }

        scheduleList.push(item);
      });
      return scheduleList;
    }
  }, {
    key: "getFormatValue",
    value: function getFormatValue(index) {
      var divider = this.root.getDivider();
      var colTime = 60 / divider;
      var st = colTime * index;
      var et = colTime * (index + 1);
      return "".concat(formatTime(st), "-").concat(formatTime(et));
    }
  }]);

  return SchedulePanel;
}();
export function formatTime(time) {
  return "".concat(padding(String(time / 60 | 0), 2), ":").concat(padding(String(time % 60), 2));
}